// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-interaction-panel {
  background-color: rgb(123.75, 150, 150);
  border: solid 3px rgb(123.75, 150, 150);
  border-radius: 4px;
  margin: 25px 0;
}

.simx-interaction-panel--header {
  background-color: rgb(123.75, 150, 150);
  cursor: pointer;
  display: flex;
}

.simx-interaction-panel-header--content-block {
  flex-grow: 1;
  padding: 6px 12px 8px 10px;
}

.simx-interaction-panel-header--actions-block {
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0 10px 2px 12px;
}

.simx-interaction-panel-header--action {
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

.simx-interaction-panel-header--expand-collapse-action {
  width: 27px;
  height: 27px;
}
.simx-interaction-panel-header--expand-collapse-action .simx-icon {
  width: 100%;
  height: 100%;
  transition: transform 0.2s;
  transform: scaleY(-1);
}
.simx-collapsed .simx-interaction-panel-header--expand-collapse-action .simx-icon {
  transform: scaleY(1);
}
.simx-interaction-panel-header--expand-collapse-action .simx-icon path {
  fill: rgb(255, 255, 255);
}

.simx-interaction-panel-header--heading {
  color: rgb(255, 255, 255);
  font-weight: 600;
}

.simx-interaction-panel-pane {
  border-right: solid 1px rgb(159.1666666667, 178.3333333333, 178.3333333333);
}
.simx-interaction-panel-pane:last-of-type {
  border-right: none;
}

.simx-interaction-panel--action-block {
  background-color: rgb(123.75, 150, 150);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ui-elements/components/elements/interaction-panel/interaction-panel.component.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_theme.scss"],"names":[],"mappings":"AAGA;EACE,uCCW8B;EDV9B,uCAAA;EACA,kBEN4B;EFO5B,cAAA;AAFF;;AAKA;EACE,uCCI8B;EDH9B,eAAA;EACA,aAAA;AAFF;;AAKA;EACE,YAAA;EACA,0BAAA;AAFF;;AAKA;EACE,aAAA;EACE,mBAAA;EACF,YAAA;EACA,cAAA;EACA,wBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EAEA,qBAAA;AAHJ;AAII;EACE,oBAAA;AAFN;AAKI;EACE,wBCrC0B;ADkChC;;AAQA;EACE,yBC3C8B;ED4C9B,gBAAA;AALF;;AAQA;EACE,2EAAA;AALF;AAME;EACE,kBAAA;AAJJ;;AAQA;EACE,uCCxD8B;ADmDhC","sourcesContent":["@use 'colors';\n@use 'theme';\n\n.simx-interaction-panel {\n  background-color: colors.$simxColorLightNeutralDarkest;\n  border: solid 3px colors.$simxColorLightNeutralDarkest;\n  border-radius: theme.$simxBorderRadiusDefault;\n  margin: 25px 0;\n}\n\n.simx-interaction-panel--header {\n  background-color: colors.$simxColorLightNeutralDarkest;\n  cursor: pointer;\n  display: flex;\n}\n\n.simx-interaction-panel-header--content-block {\n  flex-grow: 1;\n  padding: 6px 12px 8px 10px;\n}\n\n.simx-interaction-panel-header--actions-block {\n  display: flex;\n    align-items: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 0 10px 2px 12px;\n}\n\n.simx-interaction-panel-header--action {\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n}\n\n.simx-interaction-panel-header--expand-collapse-action {\n  width: 27px;\n  height: 27px;\n\n  .simx-icon {\n    width: 100%;\n    height: 100%;\n    transition: transform theme.$simxTransitionSpeedDefault;\n\n    transform: scaleY(-1);\n    .simx-collapsed & {\n      transform: scaleY(1);\n    }\n\n    path {\n      fill: colors.$simxColorWhite;\n    }\n  }\n}\n\n.simx-interaction-panel-header--heading {\n  color: colors.$simxColorWhite;\n  font-weight: 600;\n}\n\n.simx-interaction-panel-pane {\n  border-right: solid 1px colors.$simxColorLightNeutralDarker;\n  &:last-of-type {\n    border-right: none;\n  }\n}\n\n.simx-interaction-panel--action-block {\n  background-color: colors.$simxColorLightNeutralDarkest;\n}\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n","$simxBorderRadiusDefault:     4px;\n$simxBorderRadiusHeavy:       calc($simxBorderRadiusDefault * 2);\n\n$simxTransitionSpeedDefault:  0.2s;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
